"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBDatepicker = require("../HBDatepicker/HBDatepicker.styles");
var _CustomHeader = _interopRequireDefault(require("../HBDatepicker/CustomHeader"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBDatepickerBase = _interopRequireDefault(require("./HBDatepickerBase"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["decreaseMonth", "increaseMonth", "decreaseYear", "increaseYear", "date"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBDatepicker = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var id = props.id,
    testIdName = props.testIdName,
    testId = props.testId,
    icon = props.icon,
    customTheme = props.customTheme,
    className = props.className,
    hasError = props.hasError,
    decreaseMonthOnClick = props.decreaseMonthOnClick,
    increaseMonthOnClick = props.increaseMonthOnClick,
    _props$datepickerType = props.datepickerType,
    datepickerType = _props$datepickerType === void 0 ? 'day' : _props$datepickerType,
    selected = props.selected,
    value = props.value,
    onChange = props.onChange;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'wrapper',
    componentName: 'HBDatepicker'
  });
  (0, _react.useEffect)(function () {
    setViewType(datepickerType);
  }, [datepickerType]);
  var _useState = (0, _react.useState)(datepickerType),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    viewType = _useState2[0],
    setViewType = _useState2[1];
  var datepickerTypeProp = {
    showMonthYearPicker: viewType === 'month',
    showYearPicker: viewType === 'year'
  };
  var renderCustomHeader = function renderCustomHeader(_ref) {
    var decreaseMonth = _ref.decreaseMonth,
      increaseMonth = _ref.increaseMonth,
      decreaseYear = _ref.decreaseYear,
      increaseYear = _ref.increaseYear,
      date = _ref.date,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var decrease = function decrease() {
      switch (viewType) {
        case 'day':
          decreaseMonth();
          break;
        case 'month':
          decreaseYear();
          break;
        case 'year':
          decreaseYear();
          break;
        default:
          // eslint-disable-next-line no-console
          console.error('unknown viewType');
          decreaseMonth();
      }
    };
    var increase = function increase() {
      switch (viewType) {
        case 'day':
          increaseMonth();
          break;
        case 'month':
          increaseYear();
          break;
        case 'year':
          increaseYear();
          break;
        default:
          // eslint-disable-next-line no-console
          console.error('unknown viewType');
          increaseMonth();
      }
    };
    return /*#__PURE__*/_react["default"].createElement(_CustomHeader["default"], (0, _extends2["default"])({
      decrease: decrease,
      onDecreaseClick: decreaseMonthOnClick,
      onIncreaseClick: increaseMonthOnClick,
      increase: increase,
      date: date,
      viewType: viewType,
      setViewType: setViewType
    }, rest));
  };
  var handleDateChange = function handleDateChange(date, event) {
    var newDate = new Date(selected || value);
    if (viewType === 'year') {
      setViewType('month');
    }
    if (viewType === 'month' && datepickerType !== 'month') {
      setViewType('day');
    }
    newDate = date;
    onChange(newDate, event);
  };
  var onClickOutside = function onClickOutside() {
    setViewType(datepickerType);
  };
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    customTheme: customTheme,
    className: className,
    hasError: hasError,
    "data-testid": finalTestId
  }, /*#__PURE__*/_react["default"].createElement(_HBDatepickerBase["default"], (0, _extends2["default"])({
    ref: ref
  }, props, datepickerTypeProp, {
    shouldCloseOnSelect: viewType === datepickerType,
    onChange: handleDateChange,
    renderCustomHeader: renderCustomHeader,
    onClickOutside: onClickOutside
  })), icon && /*#__PURE__*/_react["default"].createElement(_HBDatepicker.Calendar, {
    htmlFor: id
  }, icon));
});
var _default = exports["default"] = HBDatepicker;
var Wrapper = (0, _styledComponents["default"])(_HBDatepicker.DatePickerStyled).withConfig({
  displayName: "HBDatepicker__Wrapper",
  componentId: "sc-s105es-0"
})([""]);
//# sourceMappingURL=HBDatepicker.js.map